module.exports = __webpack_public_path__ + "static/media/021-girl-3.62dd459e.svg";